import LeftContainer from './LeftContainer';

export default LeftContainer;
